/**
 * 项目审定实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Row,
    Col,
    message,
    InputNumber,
    DatePicker,
    Input,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';

const MODULENAME_URL = CNF.navItems[0].submenu[1].url;

const { TextArea } = Input;
const { Text } = Typography;

const Entity = (props) => {
    const { open, setOpen, record, refresh } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [auditedDate, setAuditedDate] = useState(currentDate);
    const [auditedAmount, setAuditedAmount] = useState(0);
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setAuditedDate(currentDate);
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (record) {
            setAuditedDate(record.audited_date ? record.audited_date : currentDate);
            setAuditedAmount(record.audited_amount > 0 ? record.audited_amount : record.audit_amount);
        }
    }, [record]);

    const ok = () => {
        // 参数校验
        if (auditedAmount <= 0) {
            messageApi.error('审定金额不能为零！');
            return;
        }
        if (auditedDate === '') {
            messageApi.error('审定时间不能为空！');
            return;
        }

        setLoading(true);

        // 执行操作
        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                action: CNF.actionName.AUDITED,
                audited_date: auditedDate,
                audited_amount: auditedAmount,
                description: description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };



    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={record ? record.name : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>审定金额</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <InputNumber
                                style={{ width: '100%' }}
                                formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                min={0}
                                step='0.01'
                                onChange={(value) => setAuditedAmount(value)}
                                value={auditedAmount}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>审定时间</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <DatePicker
                                placeholder='请选择日期'
                                style={{ width: '100%' }}
                                onChange={(_, dateString) => setAuditedDate(dateString)}
                                value={dayjs(auditedDate, 'YYYY-MM-DD')}
                                disabled={loading}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>备注</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                rows={2}
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity